import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'react-oidc-context';
import Button from '../../01_atoms/Button/Button';
import Icon from '../../01_atoms/Icon/Icon';
import SearchBar from '../../01_atoms/SearchBar/SearchBar';
import { useUserRoleContext } from '../../../contexts/UserRoleContext';

interface titleProps {
  title: string;
  searchBar?: boolean;
  buttonLabel?: string;
  buttonAction?: (clicked: string) => void | Promise<void>;
}

function Header(props: titleProps) {
  const { title, searchBar, buttonLabel, buttonAction } = props;
  const auth = useAuth();
  const navigate = useNavigate();
  const { isAdmin } = useUserRoleContext();

  function handleClicked() {
    const path = window.location.pathname;
    const splittedPath = path.split('/');
    if (splittedPath[1] === 'admin') navigate('/admin');
    else navigate('/');
  }

  const onLogout = useCallback(() => {
    auth.signoutSilent();
    auth.removeUser();
    navigate('/home');
  }, [auth, navigate]);

  return (
    <div className="m-header">
      <button type="button" className="m-header__icon-title-button" onClick={handleClicked}>
        <Icon />
        <h1 className="m-header__title">{title}</h1>
      </button>
      <span className='m-header__spacer' />
      <div className="m-header__actions">
        {buttonAction && buttonLabel && !searchBar ? (
          <Button label={buttonLabel} type="primary" setClicked={buttonAction} />
        ) : null}
        {buttonAction && buttonLabel && searchBar ? (
          <div className="m-header__button-search">
            {isAdmin() && <Button label="Gebruikers" type="primary" setClicked={() => navigate('/users')} />}
            <Button label={buttonLabel} type="primary" setClicked={buttonAction} /> <SearchBar />
          </div>
        ) : null}
        {searchBar && !buttonLabel ? <SearchBar /> : null}
      </div>
      <Button label="Afmelden" type="primary" setClicked={onLogout} />
    </div>
  );
}

Header.defaultProps = {
  searchBar: false,
  buttonLabel: '',
  buttonAction: null,
};

export default Header;

